import React from 'react'

import ParcelActions from '../../actions/ParcelActions.js'

import {Alert, Button, Modal, ModalHeader, ModalActions} from '../UI/index.js'
import {formSpacing, FormStack, Input} from '../UI/forms/index.js'

class SendTrackTracePopup extends React.Component {
    constructor(props) {
        super(props)

        this.initialState = {
            isOpen: false,
            parcel: null,
            callback: null,
            email: '',
            loading: false,
            message: '',
            error: '',
            errors: []
        }

        this.state = JSON.parse(JSON.stringify(this.initialState))
    }

    open(parcel, email, callback) {
        this.setState({isOpen: true, parcel, email, callback})
    }

    close() {
        this.setState(this.initialState)
    }

    send() {
        const {parcel, email, callback} = this.state

        if (email) {
            this.setState({loading: true, message: '', error: ''})

            ParcelActions.sendTrackTraceEmail(parcel, email, (err, response) => {
                callback(err, response)
                this.close()
            })
        }
    }

    render() {
        const {isOpen, email, loading, message, error, errors} = this.state

        return (
            <Modal show={isOpen} style={{width: errors.length > 0 ? 800 : 400, maxWidth: '90%'}} onClose={this.close.bind(this)}>
                <ModalHeader title='Verstuur Track & Trace' />

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Input
                        label='Emailadres'
                        value={email}
                        onChange={(event) => this.setState({email: event.target.value})}
                    />
                </FormStack>

                {message &&
                    <Alert style={{marginBottom: 6}} variant='success'>{message}</Alert>
                }

                {error &&
                    <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>
                }

                {errors.length > 0 && errors.map((error, index) => {
                    return <Alert style={{marginBottom: 6}} key={`error${index}`} variant='danger'>{error}</Alert>
                })}

                <ModalActions>
                    {!message && !error &&
                        <Button
                            variant='text'
                            onClick={this.close.bind(this)}
                        >
                            Annuleren
                        </Button>
                    }

                    {!message && !error &&
                        <Button
                            variant='text'
                            loading={loading}
                            onClick={this.send.bind(this)}
                        >
                            Bevestigen
                        </Button>
                    }

                    {(message || error) &&
                        <Button
                            variant='text'
                            onClick={this.close.bind(this)}
                        >
                            Sluiten
                        </Button>
                    }
                </ModalActions>
            </Modal>
        )
    }
}

export default SendTrackTracePopup
